export const UPDATE_FOLDER_BREADCRUMB = "app/FOLDER/UPDATE_BREADCRUMB";

export const UPDATE_FOLDER_FILTERS = "app/FOLDER/UPDATE_FOLDER_FILTERS";

export const UPDATE_FOLDER_SEARCH = "app/FOLDER/UPDATE_FOLDER_SEARCH";

export const TRIGGER_FETCH = "app/FOLDER/TRIGGER_FETCH";
